import React from "react";
import { Table } from "reactstrap";
import { FormattedMessage } from "react-intl";

const CartStudentList = (props) => {
  let studentList = props.addedStudentList.map((p, i) => (
    <tr key={i}>
      <td className="ps-0">{p.name}</td>
      <td className="ps-0">{p.class.name}</td>
    </tr>
  ));

  return (
    <Table responsive>
      <thead>
        <tr>
          <th className="ps-0" style={{ borderTop: "none" }}>
            <FormattedMessage id="Name" />
          </th>
          <th className="ps-0" style={{ borderTop: "none" }}>
            <FormattedMessage id="Class" />
          </th>
        </tr>
      </thead>
      <tbody>{studentList}</tbody>
    </Table>
  );
};

export default CartStudentList;
